import { Component, Input } from '@angular/core';
import { OrderedItem } from 'ngx-web-api';
import { ViewportService } from 'app/core/services/viewport.service';

@Component({
  selector: 'fts-order-notification-item-info',
  templateUrl: './order-notification-item-info.component.html',
  styleUrls: ['./order-notification-item-info.component.scss'],
})
export class OrderNotificationItemInfoComponent {
  @Input()
  item: OrderedItem;
  @Input()
  special: string;

  constructor(public viewportService: ViewportService) {}
}
